<template>
    <div class="damage">
        <h4>{{ damage | damageLocation | capitalize }}</h4>

        <p v-if="damage.view_overview">Zie overzichtsfoto's</p>
        <p v-if="damage.view_previous">Zie voorgaande foto's</p>

        <div class="revisions" v-if="damage.revisions.length > 0">
            <Revision v-for="revision in damage.revisions" :key="revision.id" :revision="revision"></Revision>
        </div>
    </div>
</template>

<script>
	import moment from 'moment-timezone'
	import Revision from '../inspection/Revision'

	export default {
		components: { Revision },

		props: ['damage'],

		filters: {
			damageLocation (damage) {
				let location = ''

				if (damage.location) {
					location = damage.location
				}

				if (damage.amount) {
					location = location + ' ' + damage.amount
				}

				if (damage.type) {
					location = location + ' ' + damage.type
				}

				if (damage.material) {
					location = location + ' ' + damage.material
				}

				if (damage.direction) {
					location = location + ' ' + damage.direction
				}

				return location.trim()
			},

			capitalize (value) {
				if (!value) {
					return ''
				}

				value = value.toString()
				return value.charAt(0).toUpperCase() + value.slice(1)
			},

			formatDate (value) {
				return moment(value).locale('nl').format('LL')
			},

			formatInspectionType (value) {
				let types = [
					'vooropname',
					'tussenopname',
					'extra opname',
					'eindopname',
				]

				return types[value - 1]
			},
		},

		methods: {
			getStructuredImages (images) {
				return images.map((image) => {
					return {
						id: image.id,
						thumb: image.paths.hd,
						src: image.paths.hd,
						caption: image.name,
					}
				})
			},

			openLightbox (index) {
				this.$refs.lightbox.showImage(index)
			},
		},
	}
</script>